import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, SnackBarData } from '@ra-state';
import { filter } from 'rxjs/operators';
import { displayMessage } from './snackbar.action';
import { selectDisplayMessage } from './snackbar.selectors';

@Injectable({
  providedIn: 'root',
})
export class SnackBarFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  displayMessage$ = this.store$.select(selectDisplayMessage).pipe(filter((message) => message !== undefined));

  displayMessage(messageData: SnackBarData): void {
    this.store$.dispatch(displayMessage({ payload: messageData }));
  }
}
